import { ApiServiceV1 } from '@services';

export const SubstratesApiService = {
  async getAllSubstrates({ suffix }) {
    const { data } = await ApiServiceV1.get(`${suffix}/substrate/list`);

    return data || [];
  },
};
